import React, { useState } from 'react'
import { Button, Divider, Popover } from 'antd'
import { Settings2 } from 'lucide-react'
import { DownOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { ReportDataType } from '../../../redux/context/reports/types'
import DataTypeFilter from './DataTypeFilter'
import EmptyRowFilter from './EmptyRowFilter'
import LucideIcon from '../../../shared/components/LucideIcon'

interface SettingsButtonProps {
  dataTypesDisabled: boolean
  emptyRowsDisabled: boolean
}

const ContextSettingsButton: React.FC<SettingsButtonProps> = ({ dataTypesDisabled, emptyRowsDisabled }) => {
  const filters = useSelector(filtersSelector)
  const [settingsOpen, setSettingsOpen] = useState(false)

  const defaultDataTypes = [ReportDataType.actuals, ReportDataType.budget]
  const dataTypesChanged =
    !dataTypesDisabled &&
    (filters.dataTypes.length !== defaultDataTypes.length ||
      !defaultDataTypes.every(dt => filters.dataTypes.includes(dt)))
  const emptyRowsChanged = !emptyRowsDisabled && filters.displayEmptyRows
  const hasNonDefaultSettings = dataTypesChanged || emptyRowsChanged

  const activeSettingsCount =
    (!dataTypesDisabled ? filters.dataTypes.length : 0) + (!emptyRowsDisabled && !filters.displayEmptyRows ? 1 : 0)

  return (
    <Popover
      forceRender
      trigger="click"
      arrow={false}
      placement="bottomLeft"
      open={settingsOpen}
      onOpenChange={setSettingsOpen}
      content={
        <div style={{ minWidth: 240 }}>
          {!dataTypesDisabled && <DataTypeFilter />}
          {!dataTypesDisabled && !emptyRowsDisabled && <Divider style={{ margin: '12px 0' }} />}
          {!emptyRowsDisabled && <EmptyRowFilter />}
        </div>
      }
    >
      <Button
        data-cy="context-settings-button"
        className={hasNonDefaultSettings ? 'active' : undefined}
        icon={<LucideIcon icon={Settings2} />}
      >
        {activeSettingsCount > 0 && activeSettingsCount}{' '}
        <DownOutlined style={{ fontSize: 10, color: 'rgba(0, 0, 0, 0.25)' }} />
      </Button>
    </Popover>
  )
}

export default ContextSettingsButton
